@use '../../../styles/responsive.scss';

$component-name: 'grid';

.grid {
  display: grid;
  width: 100%;

  @include responsive.responsive-props($component-name, 'column-gap', 'grid-column-gap');
  @include responsive.responsive-props($component-name, 'row-gap', 'grid-row-gap');
  @include responsive.responsive-props($component-name, 'columns', 'grid-template-columns');

  .sentry {
    height: 1px;
    width: 1px;
  }
}
